import { useFilterSetData } from './useFilterSetData';

/**
 * Hook to fetch available pillars for the organization
 * using the filterset data
 */
export const usePillars = (orgId: number) => {
  const { filterSetData, loading, error } = useFilterSetData(orgId);

  // Extract the pillars array - properly handling the structure from the filterset
  const pillarsList = filterSetData?.pillars?.pillars || [];
  
  return {
    pillars: pillarsList,
    loading,
    error
  };
}; 